<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Row>
        <ColumnUi md="9">
          <Title tag="h1">Normativas</Title>
          <p>
            En esta sección econtrarás información institucional completa y
            transparente sobre el Instituto Geofísico del Perú (IGP)
          </p>
          <div class="g_info">
            <div v-for="norma in normas" :key="norma.title">
              <a :href="norma.link" target="_blank" rel="noopener noreferrer">{{
                norma.title
              }}</a>
            </div>
          </div>
        </ColumnUi>
        <ColumnUi md="3">
          <h3>En esta sección</h3>
          <List>
            <li>
              <a
                href="https://www.gob.pe/4142-instituto-geofisico-del-peru-que-hacemos"
                target="_blank"
                rel="noopener noreferrer"
                >Acerca del IGP</a
              >
            </li>
            <li>
              <a
                href="https://www.gob.pe/8304-instituto-geofisico-del-peru-organizacion-de-instituto-geofisico-del-peru"
                target="_blank"
                rel="noopener noreferrer"
                >Organización</a
              >
            </li>
            <li>
              <a
                href="https://www.gob.pe/institucion/igp/funcionarios"
                target="_blank"
                rel="noopener noreferrer"
                >Directorio de Funcionarios</a
              >
            </li>
            <li>Normativas</li>
          </List>
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<style>
.g_info {
  padding-top: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  padding-bottom: 20px;
}

.g_info div {
  background: #f1f3f4;
  padding: 10px;
  border-radius: 10px;
  width: 100%;
}

.g_info div a:before {
  content: url("../assets/browser.svg");
  padding-right: 10px;
}

.g_info div a {
  color: #211d18;
}

.g_info div a:hover {
  color: #0000af;
}
</style>
<script>
import Container from "@/components/ui/objects/Container.vue";
import Title from "@/components/ui/atoms/Title.vue";
import Trail from "@/components/common/Trail.vue";
import Row from "../components/ui/atoms/Row.vue";
import ColumnUi from "../components/ui/atoms/ColumnUi.vue";

export default {
  name: "Normativas",
  data() {
    return {
      normas: [
        {
          title: "Sistema de Control Interno IGP",
          link:
            "https://www.gob.pe/institucion/igp/colecciones/6674-sistema-de-control-interno",
        },
        {
          title: "Código de Ética institucional",
          link:
            "https://www.igp.gob.pe/informacion-institucional/codigo-etica/ce",
        },
        {
          title: "Módulo de Ecoeficiencia",
          link: "https://intranet.igp.gob.pe/ecoeficiencia/",
        },
        {
          title: "Instrumentos de Gestión",
          link:
            "https://www.igp.gob.pe/informacion-institucional/instrumentos-gestion/index",
        },
        {
          title: "Programas Presupuestales",
          link: "https://www.igp.gob.pe/informacion-institucional/ppr/",
        },
        {
          title: "Sistema de Gestión de la Calidad",
          link:
            "https://www.gob.pe/institucion/igp/campa%C3%B1as/74576-sistema-de-gestion-de-la-calidad",
        },
        {
          title: "Sistema de Gestión Antisoborno",
          link:
            "https://www.gob.pe/institucion/igp/campa%C3%B1as/74582-sistema-de-gestion-antisoborno",
        },
        {
          title: "Seguridad Salud Trabajo",
          link:
            "https://www.igp.gob.pe/informacion-institucional/seguridad_salud_trabajo/index",
        },
        {
          title: "Sistema de Gestión de Seguridad de la Información",
          link:
            "https://www.gob.pe/institucion/igp/campa%C3%B1as/74580-sistema-de-gestion-de-seguridad-de-la-informacion",
        },
        {
          title: "Integridad y Lucha Contra la Corrupción",
          link:
            "https://www.gob.pe/institucion/igp/colecciones/6571-integridad-y-lucha-contra-la-corrupcion-del-igp",
        },
        {
          title: "Sistema Integrado de Gestión",
          link:
            "https://www.gob.pe/institucion/igp/campa%C3%B1as/74293-sistema-integrado-de-gestion",
        },
      ],
    };
  },
  components: {
    Container,
    Title,
    Trail,
    Row,
    ColumnUi,
  },
};
</script>
